/**
 * Client-side CSV export utility.
 *
 * @param {Array<Object>} data   - Array of row objects
 * @param {Array<{key:string, label:string}>} columns - Column definitions
 * @param {string} filename      - Download filename (without .csv)
 */
export function exportToCSV(data, columns, filename = 'export') {
    if (!data || !data.length) return;

    const headers = columns.map(c => c.label || c.key);

    const escape = (val) => {
        if (val === null || val === undefined) return '';
        const str = String(val);
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    };

    const rows = data.map(row =>
        columns.map(col => {
            // Support nested keys like "metrics.preboarding"
            const keys = col.key.split('.');
            let val = row;
            for (const k of keys) {
                val = val?.[k];
            }
            return escape(val);
        }).join(',')
    );

    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

/**
 * Convert simple chart data (label/value arrays) to CSV-friendly format.
 */
export function exportChartToCSV(data, labelKey = 'label', valueKey = 'value', filename = 'chart-data') {
    if (!data || !data.length) return;
    const columns = [
        { key: labelKey, label: 'Label' },
        { key: valueKey, label: 'Value' },
    ];
    exportToCSV(data, columns, filename);
}
